/**
 * Profiles Endpoints - Centralized API URLs
 */

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const PROFILES_ENDPOINTS = {
  BASE: `${API_URL}/profiles`,
  GET: `${API_URL}/profiles`,
  SAVE: `${API_URL}/profiles`,
} as const;

export default PROFILES_ENDPOINTS;
